module.exports = __webpack_public_path__ + "1638de556ca2eff658a18252864cbd11.svg";